import axios from 'axios';
import {Project} from 'rendition-core/types/Rendition';

export async function getProjectById({userId, projectId}: {userId: string; projectId: string}) {
    const res = await axios.get<{project: Project}>(`/project/${projectId}`, {
        params: {userId},
    });

    return res.data.project;
}

export interface File {
    name: string;
    path: string;
    type: 'file';
    // base64 encoded contents
    contents: string;
}

export interface Directory {
    name: string;
    path: string;
    type: 'dir';
    children: Array<File | Directory>;
}

export interface FileTree {
    name: string;
    root: true;
    type: 'dir';
    children: Array<File | Directory>;
}

export async function getProjectGithubFiles({userId, projectId}: {userId: string; projectId: string}) {
    const res = await axios.get<{contents: FileTree}>(`/github/projects/${projectId}/files`, {
        params: {userId},
    });

    return res.data.contents;
}

export async function createPRForProject({userId, projectId}: {userId: string; projectId: string}) {
    const res = await axios.post<{pr: {html_url: string}}>(
        `/github/projects/${projectId}/pr`,
        {},
        {
            params: {userId},
        }
    );

    return res.data;
}
